var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modify-success"},[_vm._v("密码重置成功！")])}
var staticRenderFns = []

export { render, staticRenderFns }